import { render, staticRenderFns } from "./EventFormSessions.vue?vue&type=template&id=ec4c1c9c&scoped=true"
import script from "./EventFormSessions.vue?vue&type=script&lang=js"
export * from "./EventFormSessions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec4c1c9c",
  null
  
)

export default component.exports